document.addEventListener("DOMContentLoaded", function(){
  function setVw() {
    let vw = document.documentElement.clientWidth / 100;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
  }
  setVw();
  window.addEventListener('resize', setVw);

  if ($('[data-change-collection]').length){
    $(document).on('click', '[data-change-collection]', function(){
      activeCollection = $(this).data('change-collection');
      $('[data-change-collection]').removeClass('active');
      $(this).addClass('active');
      $('[data-collection]').removeClass('visible');
      $('[data-collection="'+ activeCollection +'"]').addClass('visible');
      carousel = document.querySelector('[data-collection="'+ activeCollection +'"]');
      if (carousel.classList.contains('enable-slider-mobile')){
        flkty = new Flickity(carousel);
        flkty.resize();
      }
    });
  }

  $(document).on('click', '[data-toggle-collapsible]', function(e) {
    e.preventDefault();
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'false');
    collapsible_container = $(this).parents('[data-collapsible-container]');
    collapsible_container.find('[data-collapsible-content]').slideToggle();
  });
});
